<script setup>
import { ref, onMounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from "primevue/useconfirm"
import axios from "axios"
import { FilterMatchMode } from 'primevue/api'
import login1img from '../assets/images/login1.svg'
import login2img from '../assets/images/login2.svg'
import login3img from '../assets/images/login3.svg'
import login4img from '../assets/images/login4.svg'

const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()

const country_code = ref('+41')
const country_codes = ref([
    {"code": "+41", "value": "+41"},
    {"code": "+49", "value": "+49"}
])
const activeTabIndex = ref(0)

const token = ref('')
const workflow_id = ref('')
const random_image_number = ref(1)
const login_image = ref(null)
const get_login_image = () => {
    random_image_number.value = Math.floor(Math.random() * 4) + 1
    if (random_image_number.value == 1) login_image.value = login1img
    if (random_image_number.value == 2) login_image.value = login2img
    if (random_image_number.value == 3) login_image.value = login3img
    if (random_image_number.value == 4) login_image.value = login4img
}

onMounted(() =>{
    get_login_image()
    token.value = localStorage.getItem('token')
    workflow_id.value = localStorage.getItem('workflow_id')
    if (token.value) {
        console.log("verify_token 1", token.value, workflow_id.value)
        verify_token()
    }
})

const login = ref(false)
const mobile = ref('')
const token_login = ref(false)
const login_error = ref(false)
const logout_message = ref(false)
const admin_login = () => {
    console.log(mobile.value)
    loader.value = true
    logout_message.value = false
    let mobile_number = mobile.value
    mobile_number = mobile_number.replace(/ /g, '')
    mobile_number = mobile_number.replace('0', country_code.value)
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/send-2fa', {number: mobile_number, partner: "GARTENKULTUREXTTEAM"})
    .then(response => {
        console.log(response.data)
        if (response.data.message == 'error') {
            toast.add({severity: 'error', summary: 'Fehler', detail: 'Es ist ein Fehler aufgetreten', life: 3000})
            login_error.value = true
            loader.value = false
        }
        if (response.data.message == 'success') {
            toast.add({severity: 'success', summary: 'SMS gesendet', detail: 'Die SMS wurde erfolgreich gesendet', life: 3000})
            token_login.value = true
            login_error.value = false
            workflow_id.value = response.data.workflow_id
            localStorage.setItem('workflow_id', workflow_id.value)
            loader.value = false
        }
    })
}

const sms_error = ref(false)
const sms_token = ref('')
const user_name = ref('')
const user_courses = ref('')
const verify_sms_token = () => {
    loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/verify-sms-token', {code: sms_token.value, workflow_id: workflow_id.value})
    .then((response) => {
        console.log(response.data)
        if (response.data.message == 'success') {
            login.value = true
            token.value = response.data.token
            localStorage.setItem('token', token.value)
            user_name.value = response.data.user.first_name + ' ' + response.data.user.last_name
            user_courses.value = response.data.user.courses
            sms_error.value = false
            loader.value = false
        } else {
            sms_error.value = true
            loader.value = false
        }
    })
}

const verification_loader = ref(false)
const verify_token = () => {
    verification_loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/verify-token', {workflow_id: workflow_id.value, token: token.value})
    .then((response) => {
        console.log("verify_token 2", response.data)
        if (response.data.message == 'success') {
            user_name.value = response.data.user.first_name + ' ' + response.data.user.last_name
            user_courses.value = response.data.user.courses
            login.value = true
            verification_loader.value = false
        } else {
            admin_logout()
            verification_loader.value = false
        }
    })
}

const admin_logout = () => {
    token.value = ''
    workflow_id.value = ''
    localStorage.removeItem('token')
    localStorage.removeItem('workflow_id')
    login.value = false
    token_login.value = false
    login_error.value = false
    sms_error.value = false
    logout_message.value = true
}

const open_url = (url) => {
    window.open(url, '_blank')
}

const swiss_date_time = (date) => {
    return new Date(date).toLocaleDateString('de-CH', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
}

const swiss_date = (date) => {
    return new Date(date).toLocaleDateString('de-CH', { year: 'numeric', month: '2-digit', day: '2-digit' })
}

const copy_to_clipboard = (value) => {
    navigator.clipboard.writeText(value)
    toast.add({severity:'success', summary: 'Erfolgreich', detail: 'In Zwischenablage kopiert', life: 3000});
}

</script>

<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>

<template>
    <Toast />
    <ConfirmDialog />
    <ProgressSpinner v-if="loader == true" style="position: fixed; z-index: 999; overflow: show; margin: auto; top: 0; left: 0; bottom: 0; right: 0; width: 50px; height: 50px;" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" aria-label="Loading..." />
    <div v-if="!verification_loader" class="flex justify-content-center mt-6">
        <div class="surface-card p-4 shadow-3 border-round" style="width: 80%" >
            <div class="flex justify-content-between">
                <img src="../assets/images/snappy_onyx_small.png" width="200" />
            </div>
            <div class="flex justify-content-end">
                <div v-if="login" class="flex justify-content-end flex-wrap" style="max-width: 200px">
                    <div class="flex align-items-center" style="width: 150px">
                        <i class="pi pi-user mr-2"></i>
                        <span>{{ user_name }}</span>
                    </div>
                    <div class="flex align-items-center mt-2 cursor-pointer hover:text-primary" style="width: 150px" @click="admin_logout()">
                        <i class="pi pi-sign-out mr-2"></i>
                        <span>Logout</span>
                    </div>
                </div>
            </div>
            <div v-if="!login" class="mt-6 p-10 fadein animation-duration-1000">
                <div class="w-full">
                    <div class="flex justify-content-center">
                        <img v-if="login_image" :src="login_image" width="400" />
                    </div>
                </div>
                <div class="w-full mt-4">
                    <div class="flex justify-content-center">
                        <h2 class="font-bold">Gartenkultur Team</h2>
                    </div>
                </div>
                <div v-if="!token_login" class="w-full mt-6">
                    <div class="flex justify-content-center">
                        <FloatLabel>
                            <Dropdown v-model="country_code" :options="country_codes" optionLabel="code" optionValue="value" class="w-7rem mr-2" />
                            <label for="country_code">Land</label>
                        </FloatLabel>
                        <FloatLabel>
                            <InputMask id="mobile" v-model="mobile" mask="079 999 99 99" autoClear autofocus placeholder="079 123 45 67" class="w-9rem" />
                            <label for="mobile">Handy-Nr</label>
                        </FloatLabel>
                    </div>
                </div>
                <div v-if="!token_login" class="w-full">
                    <div class="mt-4 flex justify-content-center">
                        <Button :disabled="mobile.length != 13" label="Login" icon="pi pi-mobile" rounded @click="admin_login()" class="mt-2" />
                    </div>
                </div>
                <div v-if="token_login" class="w-full mt-6">
                    <div class="flex justify-content-center">
                        <FloatLabel>
                            <InputMask id="sms_token" v-model="sms_token" mask="9999" autoClear autofocus placeholder="1234" class="w-6rem" />
                            <label for="sms_token">SMS-Code</label>
                        </FloatLabel>
                    </div>
                </div>
                <div v-if="token_login" class="w-full">
                    <div class="mt-4 flex justify-content-center">
                        <Button :disabled="sms_token.length != 4" label="Login" icon="pi pi-sign-in" rounded @click="verify_sms_token()" class="mt-2" />
                    </div>
                </div>
            </div>

            <div v-if="login" class="mb-5">
                <div v-if="!loader">
                    <div class="mt-3">
                        <TabView class="col-12" ref="tabview4" v-model:activeIndex="activeTabIndex">
                            <TabPanel>
                                <template #header>
                                    <i class="pi pi-graduation-cap mr-2"></i>
                                    <span class="mr-2">Ausmessung: KundenNamen, KundenOrt, Projektnummer</span>
                                </template>
                                Hier kommt ein Interface für die Ausmessung<br /><br />
                                - Checklisten<br />
                                - Upload für Bilder<br />
                                - Upload für Videos<br />
                                - Upload für Pläne<br />
                                - Zusatz-Infos<br />
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="flex justify-content-center">
                    <div class="mt-6">
                        <span class="text-gray-500">©2025 <span class="font-bold hover:text-primary cursor-pointer" @click="open_url('https://www.snappy.works')">Snappy GmbH</span>. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>